import { render } from "./horizontal-nav.vue?vue&type=template&id=f1b5a5a6&scoped=true"
import script from "./horizontal-nav.vue?vue&type=script&lang=js"
export * from "./horizontal-nav.vue?vue&type=script&lang=js"

import "./horizontal-nav.vue?vue&type=style&index=0&id=f1b5a5a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b5a5a6"]])

export default __exports__